// extracted by mini-css-extract-plugin
export default {"root":"assign_root__VK6lx"};